import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-173">
      <div className="max-w-4xl mx-auto text-center" data-id="element-174">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-175">
          <span className="text-4xl" data-id="element-176">🏉</span> COACHLABS™ UK
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-177">
          Elite coaching resources for grassroots rugby.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-178">
          Coaching rugby should be a joy, not extra admin.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-179">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-180">
            <span data-id="element-181">📧</span> support.coachlabs@gmail.com
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-182">
            <span data-id="element-183">📲</span> @coachlabs.uk
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-184">
            <span data-id="element-185">🌐</span> www.rugbyready.co.uk
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-186" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-187">
          © COACHLABS™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}